<nav tabindex="-1" class="w-full py-4 bg-white dark:bg-black dark:border-b-1 dark:border-gray-700"
    [class.bg-white]="transparent()">
    <div class="max-w-7xl mx-auto px-4 xl:px-0">
        <div class="flex flex-row items-center justify-between gap-4">
            @if (mobileMenuOpen()) {
            <p-button variant="outlined" [rounded]="true" severity="secondary" icon="pi pi-times"
                aria-label="{{ 'navbar.close' | translate }}" title="{{ 'navbar.close' | translate }}"
                styleClass="h-11! w-11!" (click)="mobileMenuOpen.set(!mobileMenuOpen())">
            </p-button>
            } @else {
            <p-button variant="outlined" [rounded]="true" severity="secondary" icon="pi pi-bars"
                aria-label="{{ 'navbar.open' | translate }}" title="{{ 'navbar.open' | translate }}"
                styleClass="h-11! w-11! lg:hidden" (click)="mobileMenuOpen.set(!mobileMenuOpen())">
            </p-button>
            }

            <a routerLink="/">
                <img src="./images/logo.svg" alt="truckhandel.ch Logo" width="{160}" height="{60}"
                    class="h-12 w-auto" />
            </a>

            <div class="hidden lg:flex grow items-center justify-center gap-1 align-center">
                <a (click)="searchMenu.toggle($event)"
                    class="flex flex-col w-25 items-center rounded-lg p-2 transition hover:bg-blue-100/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 hover:cursor-pointer">
                    <div class="flex items-center gap-1">
                        <i class="pi pi-search text-blue-600 text-xl! dark:text-blue-400"></i>
                        <i class="pi pi-chevron-down text-blue-600 text-[9px]! dark:text-blue-400"></i>
                    </div>
                    <span class="text-gray-600 dark:text-white">{{ 'navbar.search.base' | translate }}</span>
                </a>
                <p-menu #searchMenu [model]="searchItems" [popup]="true">
                    <ng-template #item let-item>
                        <a [routerLink]="item.link"
                            class="flex items-start gap-3 rounded-md px-2 py-1.5 text-left outline-none">
                            <i [class]="item.icon" class="mt-0.5 text-base! text-blue-600 dark:text-blue-400"></i>
                            <span class="flex flex-col">
                                <span class="text-sm font-medium text-gray-900 dark:text-white">
                                    {{ item.title }}
                                </span>
                                <span class="text-xs text-gray-500 dark:text-gray-400">{{ item.subtitle }}</span>
                            </span>
                        </a>
                    </ng-template>
                </p-menu>

                <a routerLink="/listings"
                    class="flex flex-col w-25 align-center items-center rounded-lg p-2 hover:bg-blue-100/20">
                    <i class="pi pi-globe text-blue-600 text-xl! dark:text-blue-400"></i>
                    <span class="text-gray-600 dark:text-white">{{ 'navbar.browse' | translate }}</span>
                </a>

                @if (showSellButton() === true) {
                <a routerLink="/sell"
                    class="flex flex-col w-25 align-center items-center rounded-lg p-2 hover:bg-blue-100/20">
                    <i class="pi pi-money-bill text-blue-600 text-xl! dark:text-blue-400"></i>
                    <span class="text-gray-600 dark:text-white">{{ 'navbar.sell' | translate }}</span>
                </a>
                }

                @if (showDealerButton() === true) {
                <a routerLink="/dealer"
                    class="flex flex-col w-25 align-center items-center rounded-lg p-2 hover:bg-blue-100/20">
                    <i class="pi pi-money-bill text-blue-600 text-xl! dark:text-blue-400"></i>
                    <span class="text-gray-600 dark:text-white">{{ 'navbar.dealer' | translate }}</span>
                </a>
                }
            </div>

            <div class="lg:ml-auto flex items-center gap-3">
                <app-language-switcher></app-language-switcher>
                <app-user-menu></app-user-menu>
            </div>
        </div>
    </div>
</nav>
@if (loadingService.showProgressBar()) {
<p-progressbar mode="indeterminate" class="h-[5px]!" color="#155dfc" />
}
<div class="hidden absolute top-[80px] left-0 w-full h-screen bg-white z-100 border-t border-gray-200"
    [class.flex!]="mobileMenuOpen()">
    <div class="p-4 pt-6 w-full space-y-6">
        @if(!profileSubMenuOpen() && !dealerSubMenuOpen()) {
        <section>
            <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-0">
                {{ 'navbar.search.title' | translate }}
            </h2>
            <ul class="mt-3 space-y-2">
                <li>
                    <a routerLink="/search/advanced"
                        class="flex items-start gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-sliders-h text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{
                                'navbar.search.advanced.title' | translate
                                }}</span>
                            <span class="mt-0.5 block text-xs text-gray-500">{{
                                'navbar.search.advanced.subtitle' | translate
                                }}</span>
                        </div>
                        <i class="pi pi-chevron-right text-xs text-gray-400 ml-auto"></i>
                    </a>
                </li>
                <li>
                    <a routerLink="/search/dealer"
                        class="flex items-start gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-building text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{
                                'navbar.search.dealer.title' | translate
                                }}</span>
                            <span class="mt-0.5 block text-xs text-gray-500">{{
                                'navbar.search.dealer.subtitle' | translate
                                }}</span>
                        </div>
                        <i class="pi pi-chevron-right text-xs text-gray-400 ml-auto"></i>
                    </a>
                </li>
                <li>
                    <a routerLink="/listings"
                        class="flex items-start gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-globe text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'navbar.browse' | translate }}</span>
                            <span class="mt-0.5 block text-xs text-gray-500">{{
                                'navbar.descriptions.browse' | translate
                                }}</span>
                        </div>
                        <i class="pi pi-chevron-right text-xs text-gray-400 ml-auto"></i>
                    </a>
                </li>
            </ul>
        </section>

        <section>
            <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-0">{{ 'navbar.profile' |
                translate }}</h2>
            <ul class="mt-3 space-y-2">

                @if (authentication.user()) {
                <li>
                    <a (click)="profileSubMenuOpen.set(!profileSubMenuOpen())"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50 hover:cursor-pointer">
                        <i class="pi pi-user text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'navbar.profile' | translate }}</span>
                        </div>
                        <i class="pi pi-chevron-right text-xs text-gray-400 ml-auto"></i>
                    </a>
                </li>
                }@else {
                <li>
                    <a routerLink="/auth/login"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-sign-in text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'navbar.login' | translate }}</span>
                        </div>
                        <i class="pi pi-chevron-right text-xs text-gray-400 ml-auto"></i>
                    </a>
                </li>
                }

                @if (showSellButton() === true) {
                <li>
                    <a routerLink="/sell"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-building text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'navbar.sell' | translate }}</span>
                        </div>
                        <i class="pi pi-chevron-right text-xs text-gray-400 ml-auto"></i>
                    </a>
                </li>
                }

                @if (showDealerButton() === true) {
                <li>
                    <a (click)="dealerSubMenuOpen.set(!dealerSubMenuOpen())"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50 hover:cursor-pointer">
                        <i class="pi pi-building text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'navbar.dealer' | translate }}</span>
                        </div>
                        <i class="pi pi-chevron-right text-xs text-gray-400 ml-auto"></i>
                    </a>
                </li>
                }
            </ul>
        </section>
        }

        @if (profileSubMenuOpen()) {
        <section>
            <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-0">{{
                'navbar.back' | translate }}</h2>
            <ul class="mt-3 space-y-2">
                <li>
                    <a (click)="profileSubMenuOpen.set(!profileSubMenuOpen())"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50 hover:cursor-pointer">
                        <i class="pi pi-arrow-left text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'navbar.back' | translate }}</span>
                        </div>
                    </a>
                </li>
            </ul>
        </section>

        <section>
            <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-0">{{
                'profile.sidebar.groups.profile' | translate }}</h2>
            <ul class="mt-3 space-y-2">
                <li>
                    <a routerLink="/profile/dashboard"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-th-large text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'profile.sidebar.links.overview' | translate
                                }}</span>
                        </div>
                    </a>
                </li>

                <li>
                    <a routerLink="/profile/favorites"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-heart text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'profile.sidebar.links.favorites' | translate
                                }}</span>
                        </div>
                    </a>
                </li>

                <li>
                    <a routerLink="/profile/follows"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-users text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'profile.sidebar.links.followers' | translate
                                }}</span>
                        </div>
                    </a>
                </li>

                <li>
                    <a routerLink="/profile/edit"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-pencil text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'profile.sidebar.links.edit' | translate
                                }}</span>
                        </div>
                    </a>
                </li>

                <li>
                    <a (click)="authentication.logout()"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50 hover:cursor-pointer">
                        <i class="pi pi-sign-out text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'navbar.logout' | translate
                                }}</span>
                        </div>
                    </a>
                </li>
            </ul>
        </section>
        }

        @if (dealerSubMenuOpen()) {
        <section>
            <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-0">{{
                'navbar.back' | translate }}</h2>
            <ul class="mt-3 space-y-2">
                <li>
                    <a (click)="dealerSubMenuOpen.set(!dealerSubMenuOpen())"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50 hover:cursor-pointer">
                        <i class="pi pi-arrow-left text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'navbar.back' | translate }}</span>
                        </div>
                    </a>
                </li>
            </ul>
        </section>

        <section>
            <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-0">{{
                'dealer.sidebar.groups.dealer' | translate }}</h2>
            <ul class="mt-3 space-y-2">
                <li>
                    <a routerLink="/dealer/dashboard"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-th-large text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'dealer.sidebar.links.overview' | translate
                                }}</span>
                        </div>
                    </a>
                </li>

                <li>
                    <a routerLink="/dealer/listings"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-list text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'dealer.sidebar.links.listings' | translate
                                }}</span>
                        </div>
                    </a>
                </li>

                <li>
                    <a routerLink="/dealer/followers"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-users text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'dealer.sidebar.links.followers' | translate
                                }}</span>
                        </div>
                    </a>
                </li>

                <li>
                    <a routerLink="/dealer/embed"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-desktop text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'dealer.sidebar.links.embed' | translate
                                }}</span>
                        </div>
                    </a>
                </li>
            </ul>
        </section>

        <section>
            <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-0">{{
                'dealer.sidebar.groups.settings' | translate }}</h2>
            <ul class="mt-3 space-y-2">
                <li>
                    <a routerLink="/dealer/edit"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-pencil text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'dealer.sidebar.links.edit' | translate
                                }}</span>
                        </div>
                    </a>
                </li>

                <li>
                    <a routerLink="/dealer/subscription"
                        class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50">
                        <i class="pi pi-cog text-blue-600 text-lg!"></i>
                        <div class="flex flex-col ml-1">
                            <span class="block text-sm text-gray-900">{{ 'dealer.sidebar.links.subscription' | translate
                                }}</span>
                        </div>
                    </a>
                </li>
            </ul>
        </section>
        }

        <section>
            <h2 class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-0">§Sprache</h2>
            <ul class="mt-3 space-y-2">
                <li>
                    <app-language-switcher [mobile]="true"></app-language-switcher>
                </li>
            </ul>
        </section>
    </div>
</div>